import { SET_SUPER_ADMIN, SET_CURSOR_X } from './types.js'

export default {
  setCursorX({ commit }, payload) {
    commit(SET_CURSOR_X, payload)
  },
  setSuperUser({ commit }, payload) {
    commit(SET_SUPER_ADMIN, payload)
  },
}
